import { useMemo } from 'react';
import { useAppStore } from 'store/app/appStore';
import { useIsPortrait } from 'shared/hooks/useIsPortrait';
import { useCampaignType, useIsHeaderCollapsed, useHasMany } from '../../store/campaignsStore';
import { getBackgroundImageUrlWithType } from '../../utils/resourceLoader';
import type { ResourceType, CampaignTypes } from '../../types/campaign.types';

export const useCampaignBackgroundImage = (resources: ResourceType, overrideCampaignType?: CampaignTypes) => {
  const { viewMode } = useAppStore.getState();
  const isPortrait = useIsPortrait();
  const isCollapsed = useIsHeaderCollapsed();
  const storeCampaignType = useCampaignType();
  const campaignType = overrideCampaignType || storeCampaignType;
  const hasMany = useHasMany(campaignType);

  const backgroundImageUrl = useMemo(() => {
    const { backgroundImage } = getBackgroundImageUrlWithType(
      resources,
      isPortrait,
      isCollapsed,
      campaignType,
      viewMode,
      hasMany,
    );
    return backgroundImage;
  }, [resources, isPortrait, isCollapsed, campaignType, viewMode, hasMany]);

  return {
    backgroundImageUrl,
  };
};
